import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch", "error"];
import { useSearchTicketsForNavigationQuery } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.hooks';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { getIsPreview } from '../utils/isPreview';
import { generateDateFilter, sortFieldsToStrings } from '../constants/filters';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
import { getPreviewNavigationTickets } from './previewMocks';
const DEFAULT_NAV_PAGE_LENGTH = 10;
const NAV_POLL_INTERVAL = 300000;
export const useTicketSearchForNavigation = ({
  pageLength = DEFAULT_NAV_PAGE_LENGTH,
  offset,
  pollInterval = NAV_POLL_INTERVAL,
  sort,
  searchString,
  createDateFilter,
  lastActivityFilter,
  ticketView,
  statusFilter
}) => {
  var _data$total;
  const {
    isPreview
  } = getIsPreview();
  const dateFilters = [generateDateFilter('createdate', createDateFilter), generateDateFilter('hs_lastactivitydate', lastActivityFilter)].filter(f => f != null);
  const _useSearchTicketsForN = useSearchTicketsForNavigationQuery({
      skip: isPreview,
      fetchPolicy: 'no-cache',
      variables: {
        accountId: getPortalAccountId(),
        portalInstanceId: getPortalInstanceId(),
        params: {
          ticketView,
          statusFilter,
          searchString: searchString || undefined,
          sort,
          dateFilters,
          offset,
          pageLength
        }
      },
      pollInterval,
      skipPollAttempt: () => document.visibilityState === 'hidden'
    }),
    {
      data,
      loading,
      refetch,
      error
    } = _useSearchTicketsForN,
    rest = _objectWithoutPropertiesLoose(_useSearchTicketsForN, _excluded);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });
  if (isPreview) {
    const preview = getPreviewNavigationTickets({
      searchString,
      createDateFilter,
      lastActivityFilter,
      offset,
      limit: pageLength,
      sort: sortFieldsToStrings(sort),
      statusFilter,
      ticketView
    });
    return Object.assign({
      data: preview.results,
      total: preview.total,
      refetch,
      loading: false,
      error
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.results,
    total: (_data$total = data === null || data === void 0 ? void 0 : data.total) !== null && _data$total !== void 0 ? _data$total : 0,
    refetch,
    loading,
    error
  }, rest);
};